import axios from '../base/axios';
import API_KEY from './key';

const GET_TVONAIR = 'flixfrenzy/redux/GET_TVONAIR';

// eslint-disable-next-line default-param-last
const tvOnAirReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVONAIR:
      return action.payload;
    default:
      return state;
  }
};

export const getTvOnAir = () => (dispatch) => {
  axios.get(`tv/on_the_air?api_key=${API_KEY}&language=en-US`).then((res) => {
    dispatch({
      type: GET_TVONAIR,
      payload: res.data,
    });
  });
};

export default tvOnAirReducer;
